module.exports = __webpack_public_path__ + "static/media/creative-commons-remix.bf883d91.svg";